import { panels } from '#packages/stateManagement';
import { EditorRestrictionsApiKey } from '#packages/apis';
import type { StateMapperArgs } from 'types/redux';

export const canSelectSectionLike = ({ editorAPI, state }: StateMapperArgs) => {
  const editorRestrictionsApi = editorAPI.host.getAPI(EditorRestrictionsApiKey);
  const isSelectSectionLikeInteractive = editorRestrictionsApi.allowed(
    'sections_select-sections-like.interactive',
  );
  if (editorAPI.zoomMode.isStageZoomMode() || isSelectSectionLikeInteractive) {
    return !panels.selectors.hasOpenedLeftPanels(state);
  }
  return true;
};
